<template>
  <div></div>
</template>

<script>
import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;
export default {
  data() {
    return {};
  },
  methods: {
    loading() {
      axios
        .get(
          `${this.$store.state.BASEURL}/login/lypcwechatLogin.jhtml?code=${this.$route.query.code}`
        )
        .then(res => {
          console.log('触发路径事件');
          if (res.data.type === "success") {
            this.$store.commit("saveToken", res.data.content);
            this.$store.dispatch("getMember");
            this.$message("登录成功");
            this.$router.go(-1);
          } else {
            this.$message("登录失败");
            this.$router.push({ path: "/" });
          }
        });
    }
  },
  destroyed() {},
  mounted() {
    this.loading();
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/wx.vue